import { UnallocatePaymentInput } from 'types/graphql';

import { useMutation } from '@redwoodjs/web';

import { showErrorLong, showSuccessToast } from 'src/components/Toasts/toast';
import { UNALLOCATE_PAYMENT } from 'src/graphql/mutations/unallocatePayment.mutation';
import { LogError } from 'src/lib';

export const useUnallocatePayment = (onSuccess: () => void) => {
    const [unallocatePayment, { loading }] = useMutation(UNALLOCATE_PAYMENT, {
        onCompleted: ({ unallocatePayment: { message } }) => {
            showSuccessToast(message);
            onSuccess();
        },
        onError: (error) => {
            showErrorLong(error?.message);
            LogError(error);
        },
    });

    return {
        unallocatingPayment: loading,
        handleUnallocatePayment: async (unallocatePaymentInput: UnallocatePaymentInput) =>
            await unallocatePayment({
                variables: {
                    input: unallocatePaymentInput,
                },
            }),
    };
};
